import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

const DeleteModal = ({onCancel, onConfirm, ...props}) => (
  <Dialog
    modal
    title='Delete '
    {...props}
    actions={[
      <FlatButton key={'cancel'} label='Cancel' onClick={onCancel} />,
      <FlatButton key={'ok'} label='Delete' onClick={onConfirm} primary />,
    ]}>
    The Entry will be deleted, are you shure?
  </Dialog>
);

DeleteModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default DeleteModal;



// WEBPACK FOOTER //
// ./src/arkulpa-fec/components/DeleteModal/index.js